import PropTypes from "prop-types";
import React, { useEffect } from "react";
import styled from "styled-components";
import { Tween } from "react-gsap";
import { Back } from "gsap";

const Nav = ({
  className,
  items = [],
  active,
  activeNav,
  fullpageApi,
  hover,
  setHover
}) => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      var scroller = document.getElementById("slide");
      var item = document.getElementById(`side-${active}`);
      var isEdge = navigator.userAgent.indexOf("Edge") > -1;
      var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
      if (scroller && item && !isEdge && !isIE11) {
        scroller.scrollTo({
          top: 0,
          left: item.offsetLeft,
          behavior: "smooth"
        });
        document.querySelector('.gd-bem').scrollTo(0, 0);
        document.body.scrollTo(0, 0);
      }
    }
  }, [active]);
  return (
    <nav
      className={`sideNav ${className} ${activeNav} ${
        active ? "sideNavActive" : ""
      }`}
    >
      <Tween
        wrapper={<ul id="slide" />}
        staggerFrom={{
          opacity: 0,
          cycle: {
            x: i => (i + 1) * 50
          },
          ease: Back.easeOut
        }}
        stagger={0.1}
      >
        {items.map((item, index) => {
          if (item.display === false)
            return (
              <li
                key={`li-${index}-${item.key}`}
                style={{ opacity: 0, padding: 0 }}
              />
            );
          var activeIndex = items.findIndex(i => i.key === active);
          return (
            <li
              key={`li-${index}-${item.key}`}
              id={`side-${item.key}`}
              className={
                active === item.key || hover === `${activeNav}-${item.key}`
                  ? "active"
                  : ""
              }
              onMouseEnter={() => {
                if (setHover) {
                  setHover(`${activeNav}-${item.key}`);
                }
              }}
              onMouseLeave={() => {
                if (setHover) {
                  setHover(null);
                }
              }}
            >
              <span
                // to={`/#${item.key}`}
                onClick={e => {
                  e.preventDefault();
                  fullpageApi.silentMoveTo(`${activeNav}-${item.key}`);
                }}
              >
                {item.label}
              </span>
            </li>
          );
        })}
      </Tween>
    </nav>
  );
};

//<a href={`#${activeNav}-${item.key}`}>{item.label}</a>

Nav.propTypes = {
  siteTitle: PropTypes.string
};

Nav.defaultProps = {
  siteTitle: ``
};

const StyledNav = styled(Nav)`
  top: 0px;
  margin-top: 30px;
  width: 100%;
  pointer-events: all;

  @media only screen and (max-width: ${p => p.theme.break}px) {
    margin-top: 0px;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      position: relative;
      span,
      a {
        color: ${p => p.theme.colors.text};
        padding: 13px 0 11px 0;
        display: block;
        transition: 300ms all linear;
        -webkit-backface-visibility: hidden;
        cursor: pointer;
      }

      &:after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 1px;
        background: rgba(0, 0, 0, 0.25);
        transition: 300ms all linear;
        -webkit-backface-visibility: hidden;
      }

      &:before {
        content: "";
        position: absolute;
        right: -30px;
        bottom: -5px;
        width: 11px;
        height: 11px;
        border-radius: 50%;
        background: ${p => p.theme.colors.primary};
        transition: 300ms all linear;
        -webkit-backface-visibility: hidden;
        transform: translateX(-25px) scale(0);
      }

      &.active,
      &.hover,
      &:hover {
        span,
        a {
          color: ${p => p.theme.colors.highlight}!important;
          transform: translate3d(25px, 0, 0);
        }

        &:after {
          background: ${p => p.theme.colors.primary};
          width: calc(100% + 25px);
        }

        &:before {
          transform: translateX(0px) scale(1);
        }
      }
    }
  }

  &.components,
  &.features,
  &.workflow {
    ul {
      @media only screen and (max-width: ${p => p.theme.break}px) {
        display: flex;
        overflow-x: scroll;
        overflow-y: hidden;
        overflow-scrolling: touch;
        max-width: calc(100vw - 33px);

        &:before {
          content: "";
          position: absolute;
          left: -25%;
          bottom: 0;
          width: 150%;
          height: 1px;
          z-index: 0;
          background: rgba(0, 0, 0, 0.25);
          transition: 300ms all linear;
          -webkit-backface-visibility: hidden;
        }

        li,
        a,
        span {
          white-space: nowrap !important ;
          padding: 11px 15px 8px 15px;

          &:after {
            background: transparent;
          }

          &.active,
          &:hover {
            span,
            a {
              color: ${p => p.theme.colors.highlight}!important;
              transform: translate3d(0, 0, 0);
            }

            &:after {
              background: ${p => p.theme.colors.primary};
              width: 100%;
            }

            &:before {
              display: none;
            }
          }
        }
      }
    }
  }
`;

export default StyledNav;
